import {
  Grid,
  IconButton,
  Typography,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Button,
  FormHelperText,
  Link as MuiLink
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Icon } from "../../utils/MuiIcons/Icon";
import AutoComplete from "../AutoComplete/AutoComplete";
import RadioGroupComponent from "../RadioGroupComponent/RadioGroupComponent";
import CheckBoxComponent from "../CheckBox/CheckBoxComponent";
import TransferList from "../TransferList/TransferList";
import SelectMainComponent from "../SelectComponent/SelectMainComponent";
import ImageUpload from "../../component/ImageUpload/ImageUpload";
import DateComponent from "../DateComponent/DateComponent";
import ButtonComponent from "../../component/ButtonComponent/ButtonComponent";
import AvatarComponent from "../../component/AvatarComponent/AvatarComponent";
import { serverAddress } from "../../config";
import axios from "axios";

import { Global_Data } from "../../globalData/GlobalData";
import DailogMain from "./DailogMain";
import Vartext from "../../component/VARTEXT/Vartext";
import { vsprintf } from "sprintf-js";
import NestedDialog from "./NestedDialog";
import TransferListMain from "../../component/TransferListMain/TransferListMain";
import { replaceKeywordsInText } from "../../component/Charts/dashboard.utils";
import { replacePlaceholders } from "../../component/Charts/CommonFunctions";
// Render of component start
// render typography

export const renderTypography = (data, textValue) => {
  let label = data?.component?.sLabel;
  if (label?.includes(":[")) {
    label = replaceKeywordsInText(label);
  }
  if (label?.includes("{") && textValue) {
    label = replacePlaceholders(label, textValue);
  }
  return (
    <Grid item  {...data?.grid_props} >
      <Typography id={data?.component?.sName} {...data?.component?.sProps}>
        {label}
      </Typography>
    </Grid>
  );
};

// render textfield
export const renderTextfield = (data, ind, index, error, textValue, handleTextValue, varValue) => {
  let sProps = {
    variant: "outlined"
  }
 
  return(
  <>
    <Grid item {...data?.grid_props}>
   
     <TextField
       
       id={data?.component?.sName}
       label={data?.component?.sLabel}
       helperText={error?.[data?.component?.sName]||data?.component?.sHelper}
       placeholder={
         error?.[data?.component?.sName]
           ? (error[data?.component?.sName] || data?.component?.sPlaceHolder)
           : data?.component?.sPlaceHolder
       }
       type={data?.component?.sAdornType}
      //  value={
      //   textValue[data?.component?.sName] && textValue[data?.component?.sName]?.length > 0
      //   ? textValue[data?.component?.sName]
      //   : "" || data?.validation?.sType === "COUNTER" || data?.validation?.sType === "FIXVALUE"
      //   ? data?.component?.sDefaultValue
      //   : varValue[data?.component?.sName]
      //   ? varValue[data?.component?.sName] 
      //   : ""
      //  }
      value={
        textValue[data?.component?.sName] && textValue[data?.component?.sName]?.length > 0
          ? textValue[data?.component?.sName]
          : "" || data?.validation?.sType === "COUNTER" || data?.validation?.sType === "FIXVALUE"
          ? data?.component?.sDefaultValue
          : ""
       }
       name={data?.component?.sName}
       onChange={e => handleTextValue(e, ind, data?.validation)}
       error={error && error[data?.component?.sName]  || error && error[data?.component?.sName] == ''}
       InputProps={
         data?.component?.sAdornPosition?.toLowerCase() === "start"
           ? {
               startAdornment: (
                 <>
                   {data?.component?.sAdornPosition &&
                     data?.component?.sAdornType.toLowerCase() === "icon" && (
                       <InputAdornment position={data?.component?.sAdornPosition}>
                         <Icon  sProps={data?.component?.sIconProps} iconName={data?.component?.sIcon} />
                       </InputAdornment>
                     )}
                   {data?.component?.sAdornPosition &&
                     data?.component?.sAdornType.toLowerCase() === "text" && (
                       <InputAdornment position={data?.component?.sAdornPosition}>
                         {data?.component?.sIcon}
                       </InputAdornment>
                     )}
                 </>
               )
             }
           : {
               endAdornment: (
                 <>
                   {data?.component?.sAdornPosition &&
                     data?.component?.sAdornType.toLowerCase() === "icon" && (
                       <InputAdornment position={data?.component?.sAdornPosition}>
                         <Icon sProps={data?.component?.sIconProps} iconName={data?.component?.sIcon} />
                       </InputAdornment>
                     )}
                   {data?.component?.sAdornPosition &&
                     data?.component?.sAdornType.toLowerCase() === "text" && (
                       <InputAdornment position={data?.component?.sAdornPosition}>
                         {data?.component?.sIcon}
                       </InputAdornment>
                     )}
                 </>
               )
             }
       }
   
       {...data?.component?.sProps}
       
     />
     {/* {JSON.stringify(error)} */}
    {/* - {error?.[data?.component?.sName]||data?.component?.sHelper}- */}
 {/* {error ? error?.[data?.component?.sName]? error[data?.component?.sName] :data?.component?.sHelpe:data?.component?.sHelper} */}
     {/* {error && <p style={{ color: "red" }}>{error && error[data?.component?.sName]}</p>} */}
   </Grid>
  </>
  )
};

// render link component
export const renderlinkfield = (data, handleLinkOpenModal, openStaticDialog) => {
  if (data?.data?.sAction === "DIALOG") {
    return (
      <Grid item {...data?.grid_props}>
        <MuiLink
          component="button"
          type="button"
          color="text.primary"
          onClick={() => handleLinkOpenModal(data)}
          {...data?.component?.sProps}
        >
          {data?.component?.sLabel}
        </MuiLink>
      </Grid>
    );
  }
  if (data?.data?.sAction === "STATICDIALOG") {
    return (
      <Grid item {...data?.grid_props}>
        <MuiLink
          component="button"
          type="button"
          color="text.primary"
          onClick={() => openStaticDialog(true)}
          {...data?.component?.sProps}
        >
          {data?.component?.sLabel}
        </MuiLink>
      </Grid>
    );
  }
  return (
    <Grid item {...data?.grid_props}>
      <RouterLink to={data?.data?.sDataSource} replace {...data?.component?.sProps}>
        {data?.component?.sLabel}
      </RouterLink>
    </Grid>
  );
};
// render autocomplete component
export const renderAutoComplete = (
  data,
  error,
  autoCompleteOnchange,
  handleclickdata,
  textValue,
  formIsSubmited,
  selectAndAutocompleteSname
) => (
  <Grid item {...data?.grid_props}>
    <AutoComplete
      formcallback={(e, valueObj, selectedObj) =>
        autoCompleteOnchange(
          e,
          data?.component?.sName,
          valueObj,
          selectedObj
        )
      }
      data={data}
      rowsdataID={textValue?.[data?.component?.sName]}
      formIsSubmited={formIsSubmited}
      errors={error && error[data?.component?.sName]}
      textValue1={textValue}
      handleClickOpen={handleclickdata}
      selectAndAutocompleteSname={selectAndAutocompleteSname}
    />
  </Grid>
);
// render Fixedvalue component
export const renderFixedvalue = (data, error, autoCompleteOnchange) => {
  return (
    <Grid item {...data?.grid_props}>
      <TextField
        id={data?.component?.sName}
        label={data?.component?.sLabel}
        placeholder={data?.component?.sPlaceHolder}
        helperText={data?.component?.sHelper}
        defaultValue={data?.component?.sDefaultValue || ""}
        disabled={true}
        variant={data?.component?.sProps?.variant}
        type={data?.component?.sProps?.variant}
        //  value={textValue[data?.component?.sName] || ""}
        name={data?.component?.sName}
      />
      {error && <p style={{ color: "red" }}>{error && error[data?.component?.sName]}</p>}
    </Grid>
  );
};
// render Currency component
export const renderCurrency = (
  data,
  error,
  company,
  ind,
  textValue,
  handleTextValue,
  handleTextValue1,
  autoCompleteOnchange
) => (
  <Grid item {...data?.grid_props}>
    <TextField
      type="tel"
      id={data?.component?.sName}
      label={data?.component?.sLabel || ""}
      placeholder={data?.component?.sPlaceHolder || ""}
      // defaultValue={data?.component?.sDefaultValue || ""}
      disabled={data?.component?.sProps?.disabled}
      variant={data?.component?.sProps?.variant}
      onChange={e => handleTextValue(e, ind, data?.validation)}
      onBlur={e => handleTextValue1(e, ind, data?.validation)}
      value={textValue[data?.component?.sName] || data?.component?.sDefaultValue}
      name={data?.component?.sName}
      InputProps={
        data?.component?.sAdornPosition === "start"
          ? {
              startAdornment: (
                <>
                  {data?.component?.sAdornPosition && data?.component?.sAdornType === "icon" && (
                    <InputAdornment position={data?.component?.sAdornPosition}>
                      <Icon iconName={data?.component?.sIcon?.slice(0, -4)} />
                    </InputAdornment>
                  )}
                  {data?.component?.sAdornPosition && data?.component?.sAdornType === "text" && (
                    <InputAdornment position={data?.component?.sAdornPosition}>
                      {data?.component?.sIcon}
                      {company.data?.sBaseCurrency}
                    </InputAdornment>
                  )}
                </>
              )
            }
          : {
              endAdornment: (
                <>
                  {data?.component?.sAdornPosition && data?.component?.sAdornType === "icon" && (
                    <InputAdornment position={data?.component?.sAdornPosition}>
                      <Icon iconName={data?.component?.sIcon.slice(0, -4)} />
                    </InputAdornment>
                  )}
                  {data?.component?.sAdornPosition && data?.component?.sAdornType === "text" && (
                    <InputAdornment position={data?.component?.sAdornPosition}>
                      {company?.data?.sBaseCurrency}
                    </InputAdornment>
                  )}
                </>
              )
            }
      }
    />
    {error && <p style={{ color: "red" }}>{error && error[data?.component?.sName]}</p>}
  </Grid>
);

// render COUNTER component
export const renderCounter = (data, error, autoCompleteOnchange, textValue) => {
  // console.log(data.component.sProps.disabled, "renderCounter data");
  return (
    <Grid item {...data?.grid_props}>
      <TextField
        id={data?.component?.sName}
        label={data?.component?.sLabel}
        placeholder={data?.component?.sPlaceHolder}
        defaultValue={data?.component?.sDefaultValue || ""}
        type={data?.component?.sProps?.variant}
        //  value={textValue[data?.component?.sName] || ""}
        name={data?.component?.sName}
        disabled={data?.component?.sProps?.disabled}
        variant={data?.component?.sProps?.variant}
      />
      {error && <p style={{ color: "red" }}>{error && error[data?.component?.sName]}</p>}
    </Grid>
  );
};
// render checkbox component
export const rendercheckbox = (data, handleCheckboxOnchange, textValue) => (
  <Grid item {...data?.grid_props}>
    <CheckBoxComponent
      handleCheckbox={e => handleCheckboxOnchange(e, data?.component?.sName)}
      data={data}
      textValue1={textValue}
      datacheckvalue={textValue[data?.component?.sName]}
      {...data?.component?.sProps}
    />
  </Grid>
);
// render trasferlist component
export const renderTransferList = data => (
  <Grid item {...data?.grid_props}>
    {/* <TransferList data={data} {...data?.component?.sProps} /> */}
  <TransferListMain data={data}/>
  </Grid>
);
// render radio group component
export const renderRadioGroup = (data, handleradiovalue,textValue, freeFormTabbleEditArrays, freeFormTabbleEditMainrecord, formAction) => (
  <Grid item {...data?.grid_props}>
    <RadioGroupComponent
      data={data}
      textValue={textValue}
      radiochange={e => handleradiovalue(e, data?.component?.sName)}
      {...data?.component?.sProps}
      freeFormTabbleEditArrays={freeFormTabbleEditArrays}
      freeFormTabbleEditMainrecord={freeFormTabbleEditMainrecord}
      formAction={formAction}
    />
  </Grid>
);

// render select component

export const renderSelect = (data, error, handleselectOnchange, textValue,handleclickdata,formIsSubmited,setSelectAndAutocompleteSname,setdTermDays, formAction, isDocumentSelect) => {
  return (
    <Grid item {...data?.grid_props}>
      {/* {JSON.stringify(data?.grid_props)} */}
      {/* { console.log(...data,'...data?.grid_props')} */}
      {/* {  console.log(handleselectOnchange,'handleselectOnchange called in hooks')} */}
      <SelectMainComponent
          data={data}
          setSelectAndAutocompleteSname={
            setSelectAndAutocompleteSname
          }
          formIsSubmited={formIsSubmited}
          handleClickOpen={handleclickdata}
          textValue={textValue}
          sColumnID={
            data?.component?.sName
          }
          errors={
            error &&
            error[data?.component?.sName]
          }
          {...data?.component?.sProps}
          setdTermDays={setdTermDays}
          handledatasend={(
              newValue,
              selectedObject,
              keyName
            ) => {
              const componentName =
                data?.component?.sName;

              /*
              * Convert the SELECT result into the same event shape
              * used by normal form controls.
              */
              const syntheticEvent = {
                target: {
                  name: componentName,
                  value:
                    newValue === undefined ||
                    newValue === null
                      ? ""
                      : String(newValue)
                }
              };

              handleselectOnchange(
                syntheticEvent,
                componentName,
                selectedObject
              );
            }}
          formaction={formAction}
          isDocumentSelect={
            isDocumentSelect
          }
        />
      
      {/* {error && <p style={{ color: "red" }}>{error && }</p>} */}
    </Grid>
  );
};
// render image component

export const renderImage = (data, getfilename, bodycontent, formaction) => (
  <Grid item {...data?.grid_props}>
    <ImageUpload
      data={data}
      {...data?.component?.sProps}
      getfilename={getfilename}
      apidata={bodycontent}
      formaction={formaction}
    />
  </Grid>
);
// render date component
export const renderDatecomponent = (
  data,
  handledatechange,
  textValue,
  formData,
  setTextValue,
  selectedComponentData
) => (
  <Grid item {...data?.grid_props}>
    <DateComponent
      data={data}
      setTextValue={setTextValue}
      handledatechange={e => handledatechange(e, data?.component.sName)}
      textValue={textValue}
      datavalue={textValue[data?.component?.sName]}
      datemod=""
      datatextvalue={textValue[data?.component?.sName]}
      formaction={formData && formData?.form && formData?.form?.sFormAction}
      selectedComponentData={selectedComponentData}
      {...data?.component?.sProps}
    />
  </Grid>
);

function substituteURI(uri, mappingData, substitutionData) {
  let finalURI = uri;
  for (const key in mappingData) {
    const placeholder = mappingData[key];
    const value = substitutionData[key]; 

    if (value !== undefined) {
      finalURI = finalURI.split(placeholder).join(value);
    }
  }
  return finalURI;
}

function replaceURIPlaceholders(uri, data) {
  return uri.replace(/{(\w+)}/g, (_, key) => data[key] || "");
}

function replaceURIPlaceholdersBrackets(uri, data = {}) {
  if (!uri || typeof uri !== "string") {
    return uri || "";
  }

  const safeData =
    data && typeof data === "object"
      ? data
      : {};

  return uri.replace(/\[([^\]]+)\]/g, (match, key) => {
    const cleanKey = String(key || "").trim();
    const value = safeData?.[cleanKey];

    return value !== undefined &&
      value !== null &&
      value !== ""
      ? String(value)
      : match;
  });
}

// render button component
export const renderButtonComponent = (data, handleclickdata,sFormName, formData, isResponseArrived, textValue, dialogKeyMapping, bulkData, handleButtonTerminateSignal) => (
  <Grid item {...data?.grid_props}>
    <ButtonComponent
      data={data}
      formName={sFormName}
      onClickvalue={e => {
        const dataUrls = JSON.parse(JSON.stringify(data.data));
        if(dataUrls.sAction?.includes("{")){
          dataUrls.sAction = replaceURIPlaceholders(dataUrls.sAction, textValue);
        }
        if (dataUrls?.sDataDestination?.includes("[")) {
          dataUrls.sDataDestination = substituteURI(
            dataUrls.sDataDestination,
            dialogKeyMapping || {},
            textValue || {}
          );

          // Menu-opened dialog parameters such as [doc]
          dataUrls.sDataDestination =
            replaceURIPlaceholdersBrackets(
              dataUrls.sDataDestination,
              textValue || {}
            );

          // DATAGRID-selected row fallback
          if (
            dataUrls.sDataDestination?.includes("[") &&
            bulkData &&
            typeof bulkData === "object"
          ) {
            dataUrls.sDataDestination =
              replaceURIPlaceholdersBrackets(
                dataUrls.sDataDestination,
                bulkData
              );
          }
        }
        handleclickdata(e, data?.component, dataUrls, data);
      }}
      formData={formData}
      formValues={textValue}
      isResponseArrived={isResponseArrived}
      onTerminateSignal={handleButtonTerminateSignal}
    />
  </Grid>
);

// render cards
export const renderCardComponent = (data, handleclickdata) => (
  <Grid item {...data.grid_props}>
    <Card {...data?.component?.sProps}>
      {data?.child?.map(item1 => {
        return (
          <>
            <CardActionArea>
              {item1?.component?.sType === "IMG" && (
                <CardMedia
                  {...item1?.component?.sProps}
                  image={`${serverAddress}${item1?.component?.sProps?.image}`}
                />
              )}
              {item1?.component?.sType === "TYPOGRAPHY" && (
                <CardContent>{renderTypography(item1)}</CardContent>
              )}
            </CardActionArea>
            <CardActions>
              {item1?.component?.sType === "BUTTON" ? (
                <ButtonComponent
                  data={item1}
                  onClickvalue={e => handleclickdata(e, item1?.component, item1.data)}
                />
              ) : null}
            </CardActions>
          </>
        );
      })}
    </Card>
  </Grid>
);

// render avatar component

export const avatarcomponent = data => <AvatarComponent data={data} />;

export const renderchipcomponent = data => <createChipComponent data={data} />;

export const rendervartextcomponent = (data, varValue, format,setVarValue) => {
  // const styleFormatData = format?.data?.records?.find(item => item?.sFieldName);
  // const styleFormat = format?.data?.records?.find(item1 => item1?.sFieldFormat);
  // const parsedData = styleFormat ? JSON.parse(styleFormat?.sFieldFormat) : {};
  return (
<>
<Vartext data={data} varValue={varValue} format={format} setVarValue={setVarValue} />
</>    
  );
};

export const renderglobaltextcomponent = (data, globalvariables, format) => {
  
  // const styleFormatData = format?.data?.find(item => item?.sFieldName);
  const styleFormat = format?.data ? format?.data?.records?.find(item1 => item1?.sFieldFormat) : null
  const parsedData = styleFormat ? JSON.parse(styleFormat?.sFieldFormat) : {};
  function extractUserData(dataString) {
    // Assuming the data string is in JSON-like format
    // Remove the curly braces and whitespace
    const userData = dataString.replace("{", "").replace("}", "").trim();
    
    // Return the user data
    return userData;
  }

  const globalData = JSON.parse(localStorage.getItem('globalvariables'))
  
  // alert(JSON.stringify(globalData[data.component.sDisplayField.replace(/[{}]/g, '')]))
const data3 = vsprintf(data?.component?.sDisplayFormat||"",globalData?.[data?.component?.sDisplayField.replace("{", "").replace("}", "").replace(',', '')] || ' &nbsp ')
  return (

    <Grid item {...data?.grid_props}>
      <Typography
        {...data?.component?.sProps}
        // {...(styleFormatData?.sFieldValue === getFieldValue(data?.component?.sName) && parsedData)}
      >
        {/* {data.component.sDisplayField.replace("{", "").replace("}", "")}---- */}

{/* {JSON.stringify(globalData)} */}
{/* {data.component.sDisplayField.replace("{", "").replace("}", "").replace(',', '')} */}
        {/* {JSON.stringify(globalData[data.component.sDisplayField.replace("{", "").replace("}", "").replace(',', '')])} */}
       
      {/* {data.component.sDisplayField}
      \\\\\\\\\\\\\\\\\
        {data.component.sDisplayField.replace("{", "").replace("}", "")}
        {globalvariables[data.component.sDisplayField.replace("{", "").replace("}", "")]}
        {JSON.stringify(globalData['ZipCode'])} */}
        {/* {data3} */}
          {/* {data.component.sDisplayFormat} */}
        <span dangerouslySetInnerHTML={{__html:data3}} />
        {/* {JSON.stringify(globalvariables)} */}
        {/* {JSON.stringify(globalData[data.component.sDisplayField.replace(/[{}]/g, '')])} */}
        {/* {globalvariables[extractUserData(data?.component?.sName)]} */}
      </Typography>
    </Grid>
  );
};

export const renderNestedDialog = (data,nestedDialog,dialogMode,handleClose, renderComponent) => {
  const { openModalData, setOpenModalData, setModalPrimaryKry, token,openModalChildData,setopenModalDataActive, setOpenModalChildData } = Global_Data();

  setModalPrimaryKry(data.component.sPrimaryKey);

  if (dialogMode?.options?.nested) {

    if (data?.component?.sName === dialogMode?.options?.dialog) {
      setOpenModalData(data?.component);
      
    return <NestedDialog data= {data}open={nestedDialog} handleClose={handleClose} renderComponent={renderComponent}  />
      
    }
  }
}

export const renderdialogboxcomponent = (
  data,
  open,
  handleClose,
  dialogMode,
  renderComponent,
  nestedDialog,
  nestedDialogMode,
  textValue,
  showBulkActionLoading
) => {
  const {
    openModalData,
    setOpenModalData,
    setModalPrimaryKry,
    token,
    openModalChildData,
    setopenModalDataActive,
    setOpenModalChildData,
    isOpenModalChildData,
  } = Global_Data();

  const parentBlurStyle = {
    filter: isOpenModalChildData ? "blur(3px)" : "none",
    transition: "filter 0.3s ease",
  };

  if (nestedDialogMode?.options?.nested) {
    if (data?.component?.sName === nestedDialogMode?.options?.dialog) {
      if (openModalData?.sName !== data?.component?.sName || openModalData?.sFormAction !== data?.component?.sFormAction) {
        setOpenModalData(data?.component);
        setModalPrimaryKry(data.component.sPrimaryKey);
      }

      return renderNestedDialog(
        data,
        nestedDialog,
        nestedDialogMode,
        handleClose,
        renderComponent,
      );
    }
  }

  const hasQueryParams = dialogMode?.options?.dialog?.includes('?');

  let dialogURI = dialogMode?.options?.dialog;
  if(hasQueryParams){
    const queryIndex = dialogMode?.options?.dialog?.indexOf('?');
    if(queryIndex != -1){
      dialogURI = dialogMode?.options?.dialog?.slice(0, queryIndex);
    }
  }

  if (data?.component?.sName === dialogURI) {
    if (openModalData?.sName !== data?.component?.sName || openModalData?.sFormAction !== data?.component?.sFormAction) {
      setOpenModalData(data?.component);
      setModalPrimaryKry(data.component.sPrimaryKey);
    }

    return (
      <>
        <DailogMain
          data={data}
          open={open}
          handleClose={handleClose}
          renderComponent={renderComponent}
          textValue={textValue}
          showBulkActionLoading={showBulkActionLoading}
        />
      </>
    );
  }

  if (data?.component?.sName === dialogMode?.sAdd?.sAddForm) {
    if (openModalData?.sName !== data?.component?.sName || openModalData?.sFormAction !== data?.component?.sFormAction) {
      setOpenModalData(data?.component);
      setModalPrimaryKry(data.component.sPrimaryKey);
    }
    return (
      <Grid container>
        <Dialog
          open={open}
          aria-labelledby={`${data?.component?.sName}-alert-dialog-title`}
          style={{ zIndex: "1201" }}
          aria-describedby={`${data?.component?.sName}-alert-dialog-description`}
          PaperProps={{ style: parentBlurStyle }}
        >
          <DialogTitle id={`${data?.component?.sType}-alert-dialog-title`}>
            {data?.component?.sLabel}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id={data?.component?.sName}>
              {data?.component?.sDefaultValue}
            </DialogContentText>
            <Grid item {...data?.grid_props}>
              <Grid container>{renderComponent(data?.child)}</Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }

  if(!dialogMode && !nestedDialogMode?.options?.nested){
    return (
        <Grid container>
          <Dialog
            open={open}
            aria-labelledby={`${data?.component?.sName}-alert-dialog-title`}
            style={{ zIndex: "1201" }}
            aria-describedby={`${data?.component?.sName}-alert-dialog-description`}
            PaperProps={{ style: parentBlurStyle }}
          >
            <DialogTitle id={`${data?.component?.sType}-alert-dialog-title`}>
              {data?.component?.sLabel}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id={data?.component?.sName}>
                {data?.component?.sDefaultValue}
              </DialogContentText>
              <Grid item {...data?.grid_props}>
                <Grid container>{renderComponent(data?.child)}</Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </Grid>
      );
  }
};
